import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ReactECharts from "echarts-for-react";
import rssiHistoryOptions from "./graphs-config/rssi_history";
import LocationHistory from "./common/locationHistory";
import { Link } from "react-router-dom";

import CellSignalIcon from "../../../assets/cell-signal.svg";

import { useSelector, useDispatch } from "react-redux";
import {
  fetchRSSIHistoryRequest,
  fetchLocationHistoryRequest,
} from "../../../store/actions/deviceDashboard";
import NotFound from "../Not-Found";
import SettingDropdown from "./common/SettingDropdown";
import ResolutionDropdown from "./common/ResolutionDropdown";

function BLEDeviceDashboard(props) {
  const { id, isRefresh } = props;
  const dispatch = useDispatch();
  const rssiHistoryFullScreenRef = useRef();
  const locationHistoryFullScreenRef = useRef();

  const isRSSIHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.rssiHistory
  );
  const isLocationHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.locationHistory
  );
  const deviceData = useSelector((state) => state.singleDeviceHeader.data);
  const rssiHistory = useSelector(
    (state) => state.deviceDashboard.data.rssiHistory
  );
  const locationHistory = useSelector(
    (state) => state.deviceDashboard.data.locationHistory
  );
  const user = useSelector(
    (state) => state.auth.user
  );

  function handleRssiHistoryResolution(val){
    dispatch(fetchRSSIHistoryRequest({
      id,
      resolutionFilterKey: "rssi",
      resolutionFilter: {
        duration: val.duration,
        resolution: val.resolution
      }
    }));
  }

  useEffect(() => {
    dispatch(
      fetchRSSIHistoryRequest({
        id,
      })
    );
    // dispatch(
    //   fetchLocationHistoryRequest({
    //     id,
    //   })
    // );
  }, [dispatch, id, isRefresh, user?.accountId]);
  return (
    <>
      <div className="view-device-dashboard-full">
        {Array.isArray(deviceData) &&
        deviceData.length > 0 &&
        deviceData[0]?.gatewayId ? (
          <div className="d-flex justify-content-start align-items-center">
            <div className="single-device-reporting-gateway">
              Reporting Gateway :
            </div>
            <Link
              to={`/devices/${deviceData[0]?.gatewayId}/dashboard`}
              className="single-device-reporting-gateway font-face-vzw px-2"
            >
              {deviceData[0]?.gatewayName}
            </Link>
          </div>
        ) : (
          <NotFound />
        )}
      </div>
      <div className="view-device-dashboard-full signalHistoryBLE" id="rssiHistory" ref={rssiHistoryFullScreenRef}>
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">RSSI History</h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown parentId="rssiHistory" parentRef={rssiHistoryFullScreenRef} isFullScreen={true}/>
              <ResolutionDropdown parentId="rssiHistory" onApply={handleRssiHistoryResolution}/>
            </div>
          </div>
          {isRSSIHistoryLoading || rssiHistory.length > 0 ? (
            <>
              <div className="d-flex flex-column mt-4 current-value-indicator">
                <div className="current-value-title">Current level</div>
                <div className="d-flex flex-row justify-content-start align-items-center current-value-count-container">
                  <h5 className="px-2 font-face-vzw current-value-count">
                    {Array.isArray(rssiHistory[rssiHistory.length - 1]) &&
                      rssiHistory[rssiHistory.length - 1].length > 1 &&
                      rssiHistory[rssiHistory.length - 1][1]}
                  </h5>
                  <img
                    src={CellSignalIcon}
                    width="24px"
                    height="24px"
                    alt="current-value-count"
                  />
                </div>
              </div>
              <ReactECharts
                style={{ height: "399px" }}
                showLoading={isRSSIHistoryLoading}
                option={{
                  ...rssiHistoryOptions,
                  xAxis: [
                    {
                      ...rssiHistoryOptions.xAxis[0],
                    },
                  ],
                  series: [
                    {
                      ...rssiHistoryOptions.series[0],
                      data: [...rssiHistory],
                    },
                  ],
                }}
              />
            </>
          ) : (
            <NotFound style={{ height: "399px" }} />
          )}
        </div>
      </div>
      {/* <div className="view-device-dashboard-full locationHistoryBLE" id="locationHistory" ref={locationHistoryFullScreenRef}>
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">Location History</h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown parentId="locationHistory" isFullScreen={true} parentRef={locationHistoryFullScreenRef} />
            </div>
          </div>
          {isLocationHistoryLoading || locationHistory.length > 0 ? (
            <LocationHistory
              isLoading={isLocationHistoryLoading}
              dataSource={locationHistory}
            />
          ) : (
            <NotFound style={{ height: "500px" }} />
          )}
        </div>
      </div> */}
    </>
  );
}
BLEDeviceDashboard.propTypes = {
  id: PropTypes.string.isRequired,
  isRefresh: PropTypes.bool.isRequired,
};
export default BLEDeviceDashboard;
